export const YuhuModules = {
  applications: 'Applications',
  amenity_bookings: 'Amenity Bookings',
};

export const ValidTriggers = {
  applications: [
    { value: 'invitation_to_apply_sent', label: 'Invitation to Apply Sent' },
    { value: 'application_submission', label: 'Application Submission' },
    { value: 'begin_application', label: 'Begin Application' },
    { value: 'cancelled_application', label: 'Cancelled Application' },
    { value: 'denied_application', label: 'Denied Application' },
    { value: 'denied_application_with_notice', label: 'Denied Application with Notice' },
  ],
  amenity_bookings: [
    { value: 'amenity_booking_confirmed', label: 'Amenity Booking Confirmed' },
    { value: 'amenity_booking_cancelled', label: 'Amenity Booking Cancelled' },
  ],
};

export const Triggers = {
  invitation_to_apply_sent: 'Invitation to Apply Sent',
  application_submission: 'Application Submission',
  begin_application: 'Begin Application',
  cancelled_application: 'Cancelled Application',
  denied_application: 'Denied Application',
  denied_application_with_notice: 'Denied Application with Notice',

  amenity_booking_confirmed: 'Amenity Booking Confirmed',
  amenity_booking_cancelled: 'Amenity Booking Cancelled',
};

export const Actions = {
  credit: 'Credit',
  debit: 'Debit',
  hold: 'Hold',
  reversal: 'Reversal',
};

export const PercentCalc = 'percent';
export const AmountCalc = 'amount';
export const CalculationTypes = {
  [PercentCalc]: 'Percentage',
  [AmountCalc]: 'Amount',
};

export const Draft = 'draft';
export const Published = 'published';
export const Archived = 'archived';
export const Statuses = {
  [Draft]: 'Draft',
  [Published]: 'Published',
  [Archived]: 'Archived',
};
